/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from 'react';
import { Button, Input, Radio, RadioGroup, Select, SelectItem } from '@nextui-org/react';
import toast from 'react-hot-toast';
import { Constants } from '../../../../utils';
import { AdminReportsService, AuthService } from '../../../../services';

const status = [
  { value: Constants.PAYMENT_STATUS.PENDING.toString(), label: 'Pendiente' },
  { value: Constants.PAYMENT_STATUS.APPROVED.toString(), label: 'Aprobado' },
  { value: Constants.PAYMENT_STATUS.REJECTED.toString(), label: 'Rechazado' },
];

const PopPaymentStatus = ({ payment, onSuccess }) => {
  const { canSubmit, canUpdateFields, form, isLoading, onChange, onSubmit, plans } = useForm(payment, onSuccess);


  return (
    <div className="py-2 w-72">
      <RadioGroup
        label="Selecciona el estatus del pago"
        value={form.status}
        onValueChange={v => onChange(v, 'status')}
      >
        {status.map(item => (
          <Radio
            isDisabled={item.value === String(Constants.PAYMENT_STATUS.PENDING)}
            value={item.value}
          >
            { item.label }
          </Radio>
        ))}
      </RadioGroup>

      {payment?.status === Constants.PAYMENT_STATUS.PENDING && (
        <>
          <Select
            label="Plan"
            labelPlacement="outside"
            placeholder=" "
            variant="bordered"
            radius="sm"
            classNames={{ mainWrapper: 'mt-4', label: 'font-semibold' }}
            disallowEmptySelection={true}
            selectedKeys={!!form.plan_id ? [form.plan_id] : []}
            onSelectionChange={v => onChange(v.currentKey, 'plan_id')}
            isDisabled={!canUpdateFields}
          >
            {plans.map((item) => (
              <SelectItem key={item.value} value={item.value}>
                { item.label }
              </SelectItem>
            ))}
          </Select>

          <Input
            type="date"
            classNames={{
              mainWrapper: 'my-4',
              base: 'w-full',
              inputWrapper: 'border-1 h-10',
              input: `pr-0 text-${!!form.next_payment ? '[]' : 'foreground-400'}`,
            }}
            label="Fecha de vencimiento"
            labelPlacement="outside"
            placeholder=" "
            variant="bordered"
            radius="sm"
            value={form.next_payment}
            onValueChange={v => onChange(v, 'next_payment')}
            isDisabled={!canUpdateFields}
          />
        </>
      )}

      <Button
        radius="sm"
        fullWidth
        color={canSubmit ? 'primary':'default'}
        isDisabled={!canSubmit || isLoading}
        isLoading={isLoading}
        onPress={onSubmit}
      >
        Guardar
      </Button>
    </div>
  )
}

const useForm = (payment, onSuccess) => {
  const userPlan = payment?.plan_users?.length ? payment?.plan_users[0] : null;
  const [isLoading, setIsLoading] = useState(false);
  const [plans, setPlans] = useState([]);
  const [form, setForm] = useState({
    id: payment.id,
    status: String(payment.status),
    plan_id: String(userPlan?.plan_id || ''),
    next_payment: userPlan?.next_payment,
  });

  const onChange = (value, target) => {
    setForm(s => ({ ...s, [target]: value }));
  }

  const onSubmit = async () => {
    if (isLoading) return;
    setIsLoading(true);

    try {
      await AdminReportsService.adminReports.updatePaymentStatus(form);
      toast.success('Pago actualizado con éxito');
      onSuccess();

    } catch (error) {
      toast.success(String(error));
    }
    setIsLoading(false);
  }

  const getPlans = async () => {
    const toSelect = (items) => items?.map(x => ({ ...x, value: String(x.id), label: x.name })) || [];

    try {
      const selects = await AuthService.getSelects();
      const planType = payment?.user?.level_id === Constants.USER.LEVELS.PROFESSOR
        ? Constants.PLAN_FOR.TEACHER
        : Constants.PLAN_FOR.SCHOOL;

      setPlans(toSelect(selects.plans.filter(x => x.for === planType)));

    } catch (error) {
      toast.error(String(error) || 'Ocurrió un error inesperado');
      return false;
    }
  }

  useEffect(() => {
    getPlans();
  }, []);

  const canSubmit = useMemo(() => {
    return form.status !== String(payment.status);
  }, [form]);

  const canUpdateFields = useMemo(() => {
    const isPending = payment?.status === Constants.PAYMENT_STATUS.PENDING;
    return canSubmit && isPending;
  }, [form]);

  return {
    canSubmit,
    canUpdateFields,
    form,
    isLoading,
    onChange,
    onSubmit,
    plans,
  }
}

export default PopPaymentStatus;